import { javaApi } from "../api/axios";

/**
 * Calls the dynamic export endpoint.
 * @param {Object} payload - { tName, cName, format }
 * @param {number|null} employeeId - optional employeeId query param
 * @returns {Blob} - the downloaded file blob
 */
export const exportData = async (payload, employeeId = null) => {
  const params = {};
  if (employeeId) params.employeeId = employeeId;

  const response = await javaApi.post("api/v1/export", payload, {
    params,
    responseType: "blob",
  });
  return response;
};
